import {TAppRootState, TSelect} from 'core/redux/types';
import {contentPageModuleName} from 'modules/content/slice';
import {IContentPageState} from 'modules/content/type';

export const select: TSelect<IContentPageState> = (state) => state[contentPageModuleName];

export const selectContentPage = (state: TAppRootState): IContentPageState['content'] => select(state).content;
